export enum FormKeys {
    ProductVariantId = 'productVariantId',
    Quantity = 'quantity',
    AddonGroups = 'addonGroups',
    RemovedIngredients = 'removedIngredients',
}

export const maxProductQuantity = 2_147_483_647
